import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import Constants from '../../config/constants';
import { Tab, Tabs, FormControl } from 'react-bootstrap';
import Layout from '../../components/layout/Layout';
import DataTable from '../../components/datatable/DataTable';
import RelationDataTable from '../../components/datatable/RelationDataTable';
import SectionEditModal from '../../modal/section/SectionEditModal';
import Alert from '../../modal/alert/Alert';
import { InfoCard } from '../../components/card/InfoCard';
import Card from '../../components/card/Card';


import { FORMATTER_STYLE, getFormatter } from '../../utils/formatter';
import { COLUMN_STYLE, getColumnStyle } from '../../components/datatable/util';
import {
  defaultRejectHandler,
  getErrorValue,
  stringifyErrorMessage,
  withDefaultSort,
} from '../../utils/utility';

import {
  getSection,
  deleteSection,
  clearErrorSection,
} from '../../redux/section/section_actions';

import {
  listComponentInSection,
  addComponentToSection,
  editComponentInSection,
  removeComponentFromSection,
} from '../../redux/section/section_component_actions';

import { searchComponentByText } from '../../redux/component/component_actions';
import SCEditorModal from '../../modal/sc_editor/SCEditorModal';

class SectionDetailPage extends React.Component {
  constructor(props) {
    super(props);

    this.search = {
      pageSize: Constants.DATA_TABLE_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    this.state = {
      categoryOption: 'all',
      isShowCreateModal: false,
      isShowEditModal: false,
      isShowDeleteModal: false,
      isDuplicateModal: false,
      isShowSCModal: false,
    };

    this.typeMapper = {
      OpaqueComponent: 'opaque component',
      TransparentComponent: 'transparent component',
    };
  }

  renderActionMenu() {
    const { t } = this.props;
    return [
      <li>
        <a
          href="#"
          data-toggle="modal"
          data-target="#edit-section"
          onClick={() => this.setState({ isShowEditModal: true })}
        >
          <i className="fas fa-edit" />
          <span className="menu-text">{t('edit section')}</span>
        </a>
      </li>,
      <li>
        <a
          href="#"
          data-toggle="modal"
          data-target="#delete-section"
          onClick={() => this.setState({ isShowDeleteModal: true })}
        >
          <i className="fas fa-trash" />
          <span className="menu-text">{t('delete section')}</span>
        </a>
      </li>,
    ];
  }

  componentDidMount() {
    this.props.getSection(this.props.match.params.sectionId);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isEditing && (nextProps.isEditing !== this.props.isEditing) && !nextProps.errorMessage) {
      this.setState({ isShowEditModal: false });
    }

    if (this.props.isDeleting && (this.props.isDeleting !== nextProps.isDeleting) && !nextProps.errorMessage) {
      this.props.history.push(`/projects/${this.props.sectionDetail.project_id}`);
    }

    if (this.props.isEditingInSection && this.props.isEditingInSection !== nextProps.isEditingInSection && !nextProps.errorMessageInSection) {
      this.setState({ isShowSCModal: false });
    }
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;

    this.props.listComponentInSection(
      this.search.pageSize,
      this.search.page,
      withDefaultSort(this.search.sorted),
      this.search.filtered,
      {
        all: null,
        public: true,
        private: false,
      }[category],
    );

    this.setState({ categoryOption: category });
  }

  dismissEditModal() {
    this.props.clearError();
    this.setState({ isShowEditModal: false });
  }

  dismissDeleteModal() {
    this.props.clearError();
    this.setState({ isShowDeleteModal: false });
  }

  renderSection(section) {
    const { isDeleting, errorMessage, t } = this.props;
    const { isShowEditModal, isShowDeleteModal } = this.state;

    const fields = [
      {
        id: 'section-name',
        label: t('name'),
        value: section.name || '-',
      },
      {
        id: 'section-area',
        label: t('area'),
        value: `${section.area === null ? '-' : getFormatter(FORMATTER_STYLE.floatFractionDigit2)(section.area)} ${t('sq m')}`,
      },
      {
        id: 'section-WWR',
        label: t('WWR'),
        value: `${section.WWR === null ? '-' : getFormatter(FORMATTER_STYLE.floatFractionDigit2)(section.WWR)}`,
      },
      {
        id: 'section-description',
        label: t('description'),
        value: section.description || '-',
      },
    ];

    return (
      <React.Fragment>
        <h1>{section.name}</h1>
        <SectionEditModal
          show={isShowEditModal}
          section={section}
          onHide={() => this.dismissEditModal()}
        />
        <Alert
          show={isShowDeleteModal}
          onHide={() => !isDeleting && this.dismissDeleteModal()}
          title={t('delete section')}
          body={`${t('do you want to delete')} ${section ? section.name : ''}?`}
          errorMessage={getErrorValue(errorMessage, 'detail')}
          primaryButtonTitle={isDeleting ? t('deleting') : t('delete')}
          primaryButtonStyle={'danger'}
          primaryButtonEnabled={!isDeleting}
          onPrimaryButtonClick={() => this.props.deleteSection(section)}
        />
        <InfoCard fields={fields} />
      </React.Fragment>
    );
  }

  renderComponent(components) {
    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coefficientColumn = getColumnStyle(COLUMN_STYLE.coefficient);
    const {
      addComponentToSection,
      editComponentInSection,
      removeComponentFromSection,
      isAddingToSection,
      isEditingInSection,
      isRemovingFromSection,
      filteredCount,
      isLoading,
      errorMessageInSection,
      sectionDetail,
      t,
    } = this.props;

    const { isShowSCModal, selectedSectionComponent } = this.state;

    const columns = [
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'component.name',
        ...textColumn,
        entity: {
          list: (text, page) => searchComponentByText(text, page)
            .then(response => response.data.map(({name, id}) => ({label: name, value: String(id)}))),
        },
      },
      {
        id: 'area',
        Header: () => <b>{`${t('area')} (${t('sq m')})`}</b>,
        accessor: 'area',
        ...coefficientColumn,
        attr: {
          type: 'number',
          isRequired: true,
          props: { min: 0.0, step: 0.001 },
        },
      },
      {
        id: 'SC',
        Header: () => <b>{t('shading coefficient')}</b>,
        accessor: item => item,
        ...coefficientColumn,
        Cell: row => {
          const {
            component: { type },
            SC,
          } = row.value;

          return type === 'TransparentComponent'
            ? (SC ? getFormatter(FORMATTER_STYLE.floatFractionDigit6)(SC) : '-')
            : t('n/a');
        },
        attr: {
          type: 'number',
          isRequired: true,
          props: { min: 0.0, step: 0.001, max: 1.0 },
        },
        renderEditCell: (row, editValue, value) => {
          const {
            component: { type },
            SC,
          } = row.value;

          if (type === 'TransparentComponent') {
            return (<FormControl
              {...this.props}
              value={value}
              // disabled={isEditing}
              type={type || 'number'}
              onChange={event => editValue(event.target.value)}
            />)
          }
          else {
            return t('n/a');
          }
        }
      },
      {
        Header: () => <b>{t('type')}</b>,
        Cell: row => t(this.typeMapper[row.value]) || '-',
        accessor: 'component.type',
        ...textColumn,
      },
    ];

    const relationship = {
      create: ({ entityId, area, SC }) => addComponentToSection(entityId, area, SC),
      edit: ({ id, area, SC }) => {
        editComponentInSection(id, area, SC);
      },
      delete: id => removeComponentFromSection(id),
      isCreating: isAddingToSection,
      isEditing: isEditingInSection,
      isDeleting: isRemovingFromSection,
    };

    return (
      <Card padding={false}>
        {isShowSCModal &&
          <SCEditorModal
            show={isShowSCModal}
            sectionComponent={selectedSectionComponent}
            azimuth={sectionDetail.envelop_azimuth_angle}
            onHide={() => this.setState({ isShowSCModal: false })}
          />
        }
        <Tabs id="envelop-section-tabs">
          <Tab title={t('components')} eventKey={1}>
            <RelationDataTable
              columns={columns}
              data={components}
              errorMessage={stringifyErrorMessage(errorMessageInSection)}
              relationship={relationship}
              onActionEdit={item => this.setState({ isShowEditModal: true, selectedInstance: item.original })}
              onActionDuplicate={item => this.setState({ isShowDuplicateModal: true, selectedInstance: item.original })}
              onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedInstance: item.original })}
              onActionCustom={item => this.setState({ isShowSCModal: true, selectedSectionComponent: item.original })}
              customActionIcon="fas fa-calculator"
              shouldShowActionMenu={(name, row) => name === DataTable.ACTION_CUSTOM ? row.original.component.type === 'TransparentComponent' : true}
              relationshipNameAccessor={item => item.component.name}
              filteredCount={filteredCount}
              isLoading={isLoading}
              onFetchData={state => this.updateSortFilter(this.search.filtered, state, this.state.categoryOption)}
            />
          </Tab>
        </Tabs>
      </Card>
    );
  }

  getBreadcrumb(section) {
    if (section.is_project_mixed_use) {
      return [
        {
          name: section.building_name,
          path: `/buildings/${section.building_id}`,
        },
        {
          name: section.name,
          path: `/sections/${section.id}`,
        },
      ];
    } else {
      return [
        {
          name: section.project_name,
          path: `/projects/${section.project_id}`,
        },
        {
          name: section.name,
          path: `/sections/${section.id}`,
        },
      ];
    }
  }

  render() {
    const { sectionDetail: section, components } = this.props;
    const breadcrumbItems = section ? this.getBreadcrumb(section) : [];

    return (
      <Layout
        history={this.props.history}
        breadcrumbItems={breadcrumbItems}
        renderActionMenu={() => this.renderActionMenu()}
      >
        {section && this.renderSection(section)}
        {section && this.renderComponent(components)}
      </Layout>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  sectionDetail: state.section.objects[ownProps.match.params.sectionId],
  isEditing: state.section.isEditing,
  isDeleting: state.section.isDeleting,
  errorMessage: state.section.errorMessage,
  components: state.section_component.orderedIds.map(id => state.section_component.objects[id]),
  isLoading: state.section_component.isLoading,
  filteredCount: state.section_component.filteredCount,
  isAddingToSection: state.section_component.isCreating,
  isEditingInSection: state.section_component.isEditing,
  isRemovingFromSection: state.section_component.isDeleting,
  errorMessageInSection: state.section_component.errorMessage,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  getSection: id => defaultRejectHandler(dispatch(getSection(id))),
  deleteSection: ({ id }) => defaultRejectHandler(dispatch(deleteSection(id))),
  addComponentToSection: (componentId, area, SC) => defaultRejectHandler(dispatch(addComponentToSection(componentId, ownProps.match.params.sectionId, area, SC))),
  editComponentInSection: (id, area, SC) => defaultRejectHandler(dispatch(editComponentInSection(id, area, SC))),
  removeComponentFromSection: id => defaultRejectHandler(dispatch(removeComponentFromSection(id))),
  listComponentInSection: (pageSize, page, sorted, filtered, isPublic) => defaultRejectHandler(dispatch(listComponentInSection(pageSize, page, sorted, filtered, isPublic, ownProps.match.params.sectionId))),
  clearError: () => dispatch(clearErrorSection()),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(SectionDetailPage),
);



// WEBPACK FOOTER //
// ./src/pages/section/SectionDetailPage.js